import config from "../config";
import BearerApi from "./bearer";
import { ProcedureType } from "../modules/utils/homologar/search/utils/constants";

class HomologarApi extends BearerApi {
  constructor(token) {
    const baseUrl = config.homologarApiUrl;
    super(baseUrl, token);
  }

  // Story 5: matcher unificado desde DB (un solo catálogo, sin split por
  // procedureType), devuelve {procedureId, name, mappedToCurrentHC}. Si todavía no
  // hay procedimientos cargados para lo que se busca (p. ej. laboratorio), simplemente
  // devuelve resultados vacíos — no hace falta ningún caso especial acá para eso.
  searchProcedures(search, limit) {
    return this.get(`/homologar/nomenclatures`, {
      search,
      ...(limit ? { limit } : {}),
    });
  }

  // useNomenclatureV3 es un opt-in por healthCenterId (ver
  // orders.homologar.nomenclatureEngine en REACT_APP_HEALTH_CENTERS_RULES): sin él,
  // todos siguen en el motor legado (JSON + Fuse.js) tal cual hoy en producción.
  searchNomenclature(search, procedureType, limit, useNomenclatureV3) {
    if (useNomenclatureV3) {
      return this.searchProcedures(search, limit);
    }
    return this.get(`/homologar/nomenclatures/${procedureType}`, {
      search,
      ...(limit ? { limit } : {}),
    });
  }

  async searchPractices(search, limit, useNomenclatureV3) {
    if (useNomenclatureV3) {
      // Ya es una única búsqueda unificada (imaging + laboratory en un solo catálogo);
      // no hay por qué pegarle dos veces al mismo endpoint. Como todavía no devuelve
      // procedureType por resultado, el chip de tipo y el límite de 1 ítem/card de
      // imaging no aplican para resultados de acá hasta que eso exista.
      return this.searchProcedures(search, limit);
    }

    const [imagingResults, laboratoryResults] = await Promise.all([
      this.searchNomenclature(search, ProcedureType.IMAGING, limit, false),
      this.searchNomenclature(search, ProcedureType.LABORATORY, limit, false),
    ]);

    const tagged = [
      ...imagingResults.map((item) => ({ ...item, procedureType: ProcedureType.IMAGING })),
      ...laboratoryResults.map((item) => ({ ...item, procedureType: ProcedureType.LABORATORY })),
    ];

    return limit ? tagged.slice(0, limit) : tagged;
  }
}

export default HomologarApi;
